import React, { useEffect } from "react";

const ZoomControl: React.FC = () => {
  useEffect(() => {}, []);

  return <React.Fragment></React.Fragment>;
};

export default ZoomControl;
